import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35c250eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-setting" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "note form-note" }, " 请注意，设置调配完成后，需要点击保存按钮才能够提交保存。否则有些配置项不能够生效。 ", -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "s-form-title" }, "界面设置", -1 /* HOISTED */))
const _hoisted_4 = { class: "language" }
const _hoisted_5 = { class: "theme" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "theme-label" }, null, -1 /* HOISTED */))
const _hoisted_7 = { class: "op-text" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "s-form-title" }, "列表设置", -1 /* HOISTED */))
const _hoisted_9 = { class: "sort" }
const _hoisted_10 = { class: "op-text" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "s-form-title" }, "页面容量设置", -1 /* HOISTED */))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "s-form-title" }, "阅读设置", -1 /* HOISTED */))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "note form-note" }, " 有朋友反馈，单手操作手机的时候，最方便触碰到屏幕的左侧，因此希望可以通过点击左侧翻下一页。那么，您可以通过此选项修改左右翻页按钮使其调换位置。 ", -1 /* HOISTED */))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "note form-note" }, " 有朋友反馈，阅读界面操作面板默认的30%-40%-30%尺寸与他的习惯不符，因此开放设置选项用以调整“顶部操作栏”与“页码器”的切换范围。 ", -1 /* HOISTED */))
const _hoisted_15 = { class: "btn-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_button, {
      type: "primary",
      onClick: $setup.user_logout
    }, {
      default: _withCtx(() => [
        _createTextVNode("登出用户")
      ]),
      _: 1 /* STABLE */
    }),
    _hoisted_2,
    _createVNode(_component_el_form, {
      model: $setup.form,
      "label-width": "10rem"
    }, {
      default: _withCtx(() => [
        _hoisted_3,
        _createCommentVNode(" 语言设置 "),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_form_item, { label: "语言设置" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: $setup.userConfig.language,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.userConfig.language) = $event)),
                class: "language-select",
                size: "default",
                onChange: $setup.language_change
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.languages, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8 /* PROPS */, ["label", "value"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _createCommentVNode(" 主题皮肤 "),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_form_item, { label: "主题设置" }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createVNode(_component_el_select, {
                modelValue: $setup.userConfig.theme,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.userConfig.theme) = $event)),
                class: "theme-select",
                size: "default",
                onChange: $setup.theme_change
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.theme, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: _ctx.$t(`theme.${item.value}`),
                      value: item.value
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: "op-color",
                          style: _normalizeStyle($setup.theme_color(item.value))
                        }, null, 4 /* STYLE */),
                        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t(`theme.${item.value}`)), 1 /* TEXT */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label", "value"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _hoisted_8,
        _createCommentVNode(" 排序方式 "),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_form_item, { label: "默认排序规则" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: $setup.userConfig.order,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.userConfig.order) = $event)),
                class: "sort-select",
                size: "default",
                onChange: $setup.sort_order_change
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.sortOrder, (item) => {
                    return _createVNode(_component_el_option, {
                      key: item,
                      label: _ctx.$t(`sortOrder.${item}`),
                      value: item
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t(`sortOrder.${item}`)), 1 /* TEXT */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label", "value"])
                  }), 64 /* STABLE_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _hoisted_11,
        _createCommentVNode(" 页面容量设置 "),
        _hoisted_12,
        _createVNode(_component_el_form_item, { label: "翻页按钮反向" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: $setup.userConfig.pageTurningReverse,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.userConfig.pageTurningReverse) = $event)),
              onChange: $setup.switch_change
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _: 1 /* STABLE */
        }),
        _hoisted_13,
        _createVNode(_component_el_form_item, { label: "显示页码" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: $setup.userConfig.showPageNumber,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.userConfig.showPageNumber) = $event))
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_el_form_item, { label: "开启滑动翻页" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: $setup.userConfig.enableTouchPageChange,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.userConfig.enableTouchPageChange) = $event))
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_el_form_item, {
          label: "顶栏切换范围",
          class: "op-range"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 4 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: $setup.userConfig.browseOperationTop,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.userConfig.browseOperationTop) = $event)),
                  type: "number"
                }, null, 8 /* PROPS */, ["modelValue"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_el_col, {
              span: 2,
              class: "text-center"
            }, {
              default: _withCtx(() => [
                _createTextVNode("%")
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_el_form_item, {
          label: "页码切换范围",
          class: "op-range"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 4 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: $setup.userConfig.browseOperationBottom,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.userConfig.browseOperationBottom) = $event)),
                  type: "number"
                }, null, 8 /* PROPS */, ["modelValue"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_el_col, {
              span: 2,
              class: "text-center"
            }, {
              default: _withCtx(() => [
                _createTextVNode("%")
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }),
        _hoisted_14
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["model"]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: $setup.submit
      }, {
        default: _withCtx(() => [
          _createTextVNode("保存设置")
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}